/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DashboardUsageAndDestroyData model module.
 * @module model/DashboardUsageAndDestroyData
 * @version 1.0
 */
class DashboardUsageAndDestroyData {
    /**
     * Constructs a new <code>DashboardUsageAndDestroyData</code>.
     * @alias module:model/DashboardUsageAndDestroyData
     */
    constructor() { 
        
        DashboardUsageAndDestroyData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DashboardUsageAndDestroyData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DashboardUsageAndDestroyData} obj Optional instance to populate.
     * @return {module:model/DashboardUsageAndDestroyData} The populated <code>DashboardUsageAndDestroyData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardUsageAndDestroyData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('usagePer')) {
                obj['usagePer'] = ApiClient.convertToType(data['usagePer'], 'Number');
            }
            if (data.hasOwnProperty('usageXper')) {
                obj['usageXper'] = ApiClient.convertToType(data['usageXper'], 'Number');
            }
            if (data.hasOwnProperty('destroyPer')) {
                obj['destroyPer'] = ApiClient.convertToType(data['destroyPer'], 'Number');
            }
            if (data.hasOwnProperty('destroyXper')) {
                obj['destroyXper'] = ApiClient.convertToType(data['destroyXper'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DashboardUsageAndDestroyData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DashboardUsageAndDestroyData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
DashboardUsageAndDestroyData.prototype['targetDate'] = undefined;

/**
 * @member {Number} usagePer
 */
DashboardUsageAndDestroyData.prototype['usagePer'] = undefined;

/**
 * @member {Number} usageXper
 */
DashboardUsageAndDestroyData.prototype['usageXper'] = undefined;

/**
 * @member {Number} destroyPer
 */
DashboardUsageAndDestroyData.prototype['destroyPer'] = undefined;

/**
 * @member {Number} destroyXper
 */
DashboardUsageAndDestroyData.prototype['destroyXper'] = undefined;






export default DashboardUsageAndDestroyData;

